import { Blogs } from '../../services/Blogs';
import { initialize } from 'redux-form';

export const SET_CURRENT_BLOG = 'SET_CURRENT_BLOG';
export const SET_BLOGS = 'SET_BLOGS';
export const DELETE_BLOG = 'DELETE_BLOG';
export const CATEGORY_ADD = 'CATEGORY_ADD';
export const CATEGORY_UPDATE = 'CATEGORY_UPDATE';
export const CATEGORY_DELETE = 'CATEGORY_DELETE';
export const TEAM_MEMBER_DELETE = 'TEAM_MEMBER_DELETE';
export const TEAM_MEMBER_ADD = 'TEAM_MEMBER_ADD';


function setCurrentBlog(blog) {
  return {
    type: SET_CURRENT_BLOG,
    blog: blog
  };
}

export function setBlogs(blogs) {
  return {
    type: SET_BLOGS,
    blogs: blogs
  };
}

export function deleteBlog(id) {
  return {
    type: DELETE_BLOG,
    id: id
  };
}

export function categoryAdd(category) {
  return {
    type: CATEGORY_ADD,
    category: category
  };
}

export function categoryUpdate(category) {
  return {
    type: CATEGORY_UPDATE,
    category: category
  };
}

export function categoryDelete(id) {
  return {
    type: CATEGORY_DELETE,
    id: id
  };
}

export function teamMemberDelete(username) {
  return {
    type: TEAM_MEMBER_DELETE,
    username: username
  };
}
export function teamMemberAdd(username, role) {
  return {
    type: TEAM_MEMBER_ADD,
    username: username,
    role: role
  };
}

export const initCurrentBlog = (blogId) => {
  return async (dispatch) => {
    try {
      const blogDetails = await Blogs.getBlog(blogId);
      console.log(blogDetails);
      dispatch(setCurrentBlog(blogDetails));
      dispatch(initialize('blog_settings', prepareBlogSettingsForm(blogDetails)));
    } catch (error) {
      console.log(error);
    }
  }
}

export const fetchBlogs = () => {
  return async (dispatch) => {
    try {
      const blogs = await Blogs.getBlogs();
      console.log(blogs);
      dispatch(setBlogs(blogs));
    } catch (error) {
      console.log(error);
    }
  }
}

export const prepareBlogSettingsForm = (databaseBlog) => {

  const {
    title,
    slogan,
    domain,
    custom_domain,
    domain_redirect,
    opengraph_default_image_url,
    opengraph_default_description,
    webmastertools_id,
    analytics_gtag,
    link_facebook,
    link_twitter,
    link_linkedin,
    link_instagram,
    logo_url,
    favicon_url,
    main_image,
    onesignal_app_id,
    onesignal_api_key,
    onesignal_body_length,
    onesignal_logo_url,
    theme,
    hidden_commenters
  } = databaseBlog;

  return {
    title,
    slogan,
    domain,
    custom_domain,
    domain_redirect,
    opengraph_default_image_url,
    opengraph_default_description,
    webmastertools_id,
    analytics_gtag,
    link_facebook,
    link_twitter,
    link_linkedin,
    link_instagram,
    logo_url,
    favicon_url,
    main_image,
    onesignal_app_id,
    onesignal_api_key,
    onesignal_body_length,
    onesignal_logo_url,
    theme,
    hidden_commenters
  }
}
